module.exports = __webpack_public_path__ + "static/media/search-5.72b44f57.png";